// extracted by mini-css-extract-plugin
module.exports = {"TextBlue":"#004258","PrimaryColor":"#1d97c1","link":"_1RbCx"};